import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import Text from "../../atoms/Text";
import Icon from "../../atoms/Icon";
import colors from "styles/colors";
import typography from "styles/typography";

const StyledTag = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ selected }) =>
    selected ? colors.primary[50] : colors.background.lightBlue};
  color: ${({ selected }) =>
    selected ? colors.primary[500] : colors.text.gray};
  padding: 8px 16px;
  border-radius: 30px;
  margin: 4px;
  cursor: ${({ onClick }) => (onClick ? "pointer" : "default")};
  transition: background-color 0.2s ease-in-out;
  .icon {
    margin: 0 4px;
    display: inline-flex;
    align-items: center;
  }

  .icon.left {
    margin-right: 8px;
  }

  .icon.right {
    margin-left: 8px;
  }
`;

const Tag = ({
  children,
  iconLeft,
  iconRight,
  onClick,
  onClickFull,
  selected = false,
  className,
}) => {
  return (
    <StyledTag
      selected={selected}
      className={className}
      onClick={onClickFull && onClickFull}
    >
      {iconLeft && (
        <div className="icon left">
          <Icon
            name={iconLeft}
            size={18}
            onClick={onClick}
            style={{ cursor: "pointer", zIndex: 99 }}
          />
        </div>
      )}
      <Text
        typography={
          selected ? typography.caption.semibold : typography.caption.regular
        }
        color={selected ? colors.primary[500] : colors.text.gray}
      >
        {children}
      </Text>
      {iconRight && (
        <div className="icon right">
          <Icon
            name={iconRight}
            size={18}
            onClick={onClick}
            style={{ cursor: "pointer", zIndex: 99 }}
          />
        </div>
      )}
    </StyledTag>
  );
};

Tag.propTypes = {
  children: PropTypes.node.isRequired,
  iconLeft: PropTypes.string,
  iconRight: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  className: PropTypes.string,
};

export default Tag;
